import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShieldCheck, X } from "lucide-react";
import { Link } from "react-router-dom";

const InfoBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setIsClosed(true);
  };

  const handleOpen = () => {
    setIsVisible(true);
    setIsClosed(false);
  };

  return (
    <>
      <AnimatePresence>
        {isVisible && (
          <motion.div
            initial={{ opacity: 0, y: 10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.95 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            className="max-w-xs sm:max-w-sm"
          >
            <div className="relative bg-white/80 backdrop-blur-md border border-border rounded-2xl shadow-soft p-4 pr-8">
              <button
                onClick={handleClose}
                className="absolute top-2.5 right-2.5 text-muted-foreground hover:text-foreground transition-colors"
                aria-label="Fermer"
              >
                <X className="w-3.5 h-3.5" />
              </button>

              <div className="flex items-start gap-3">
                <ShieldCheck className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <p className="text-xs text-foreground/80 leading-relaxed">
                  Ce site respecte votre vie privée : zéro cookie, statistiques anonymes.{" "}
                  <Link
                    to="/politique-de-confidentialite"
                    className="underline text-primary hover:text-primary/80 transition-colors"
                  >
                    Consulter notre politique de confidentialité
                  </Link>
                </p>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Petit bouton de réouverture discret */}
      <AnimatePresence>
        {isClosed && !isVisible && (
          <motion.button
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.5 }}
            onClick={handleOpen}
            className="p-2 bg-white/80 backdrop-blur-md border border-border rounded-full shadow-soft text-primary hover:scale-110 transition-transform"
            title="Politique de confidentialité"
          >
            <ShieldCheck className="w-5 h-5" />
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
};

export default InfoBanner;
